<script setup lang="ts">
import { trans } from '@tools/translation.ts';
import Typography from '@components/Typography.vue';

defineProps<{ promoteType: string }>();
</script>

<template>
  <Typography
    variant="body-bold"
    :class="`promote-type promote-type--${promoteType}`"
  >
    {{ trans(`offer.promote_type.${promoteType}`) }}
  </Typography>
</template>

<style scoped lang="scss">
.promote-type {
  @apply absolute right-1.5 -top-[18px] rotate-[4deg];

  @apply rounded-lg border border-solid;

  @apply px-2.5 py-1;

  @apply flex items-center gap-1;

  &--exclusive {
    @apply bg-purple-light;
  }

  &--premium {
    @apply bg-red-light;
  }

  &--good_deal {
    @apply bg-yellow-lightest;
  }
}
</style>
